//  const API_SERTEZA = "http://localhost/api_liga/public/api/";
//const API_SERTEZA = "https://apiliga.reydelosdeportes.com.mx/public/api/";   
//const API_SERTEZA = "https://apiliga.sistemaya.com/public/api/";   
    const API_SERTEZA = "https://apiliga.serteza.com/public/api/";   

export const SERVER_API = API_SERTEZA;